export const MINIMUM_RULER_LENGTH: number = 0.5; //mm
export const MINIMUM_ELLIPSE_AREA: number = 1.0; //mm^2
